import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { Link } from 'react-router-dom';
import formatDateToBR from '../../../utils/formatDateToBR';
import decodeHtmlEntities from '../../../utils/decodeHtmlEntities';
import NewsImage from './NewsImage';

function NewsHomeRelevantLeftComponent({ dataMostRelevantNews, isVisible, countNewsView }) {
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        if (isVisible) {
            dataMostRelevantNews.forEach((news) => {
                countNewsView({
                    newsId: news.id,
                    timestamp: Date.now(),
                });
            });
        }
    }, [isVisible, countNewsView, dataMostRelevantNews]);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    return (
        <div className="tw-container tw-mx-auto">
            {dataMostRelevantNews.slice(0, 6).map((news, index) => {
                const link = `/noticias/${news.slug}`;

                return (
                    <div key={news.id}>
                        {index !== 0 &&
                        <div className={`tw-block tw-text-left tw-w-full box ${index === 1 ? 'init' : ''}`}>
                            <Link
                                to={link}
                                title={`Saiba mais sobre ${news.title}`}
                                className="tw-block"
                            >
                                <div>
                                    <p className="alternativeFontSize tw-text-gray-500 data-publicacao">
                                        {formatDateToBR(news.date)}
                                    </p>

                                    <h3 className={`tw-mb-3 limitText2 ${index === 0 ? 'title' : ''}`}>
                                        {news.title}
                                    </h3>

                                    {index !== 0 && (
                                        <NewsImage
                                            news={news}
                                            sizes="(min-width: 1280px) 600px, (min-width: 768px) 48vw, calc(100vw - 40px)"
                                            className="tw-mt-5"
                                        />
                                    )}

                                    {index !== 0 &&
                                    <p className="tw-my-3 limitText2">
                                        {isMounted &&
                                        decodeHtmlEntities(news.content.replace(/<[^>]+>/g, ''))}
                                    </p>}
                                </div>
                            </Link>
                        </div>}
                    </div>
                );
            })}
        </div>
    );
}

NewsHomeRelevantLeftComponent.propTypes = exact({
    dataMostRelevantNews: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            date: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            slug: PropTypes.string.isRequired,
            imageNew: PropTypes.string,
            imageUrl: PropTypes.string,
            featuredImage: PropTypes.string,
            content: PropTypes.string,
        }),
    ).isRequired,
    isVisible: PropTypes.bool,
    countNewsView: PropTypes.func.isRequired,
});

export default NewsHomeRelevantLeftComponent;
